class RoleApi {

    getList() {
        var url = apiUrl + 'roles';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getListWithoutFilter() {
        var url = apiUrl + 'roles';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    get(id) {
        var url = apiUrl + 'roles/';
        return api.call('get', url + id)
            .then(({ data }) => {
                return data
            });
    }
 
    create(data) {
        var url = apiUrl + 'roles';
        return api.call('post', url, data)
            .then(({ data }) => {
                return data
            });

    }
    update(data) {
        var url = apiUrl + 'roles/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }
    delete(id) {
        var url = apiUrl + 'roles/';
        return api.call('delete', url + id)
            .then(({ data }) => {
                return data
            });
    }

    getModulesTemplate() {
        var url = apiUrl + 'roles/modules-template';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

}

export default RoleApi;